export default "__VITE_ASSET__D5PqA_V7__"